import {
  GET_DSCO_INVOICE_REPORT_REQUEST,
  GET_DSCO_INVOICE_REPORT_SUCCESS,
  GET_DSCO_INVOICE_REPORT_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getDscoInvoiceReport = (token, values) => (dispatch) => {
  dispatch({ type: GET_DSCO_INVOICE_REPORT_REQUEST });
  const newData = {
    date_from: moment(values.from_date).format("MM-DD-YYYY"),
    date_to: moment(values.to_date).format("MM-DD-YYYY"),
    customer_id: values.customer === "All" ? null : values.customer,
    invoice_no: values.invoice === undefined ? null : values.invoice
};

  return axios({
    method: "POST",
    url: `${BASEURL}getAll/DscoInvoices`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_DSCO_INVOICE_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DSCO_INVOICE_REPORT_ERROR,
        payload: [],
      });
    });
};
